var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/has-binary2/~/isarray/index.js
 ** module id = 412
 ** module chunks = 0
 **/